'use strict';

module.exports = require('./Autosuggest').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-autosuggest/dist/index.js
// module id = ./node_modules/react-autosuggest/dist/index.js
// module chunks = 2